import React from "react";

const LoginButton = ({
  wValidationCode,
  formik,
  isInvalidCombination,
  loading,
}) => {
  return (
    <button
      type="submit"
      disabled={
        !wValidationCode ? formik.isSubmitting || isInvalidCombination : false
      }
      className="btn btn-primary font-weight-bold px-6 py-3 my-3 w-100"
    >
      <span>{wValidationCode ? "Validate" : "Continue"}</span>
      {loading && <span className="ml-3 spinner spinner-white"></span>}
    </button>
  );
};

export default LoginButton;
